export const getIntegrationAgentsMap = (leasingTeams = []) => {
  const integrationAgentMap = leasingTeams.reduce(
    (integrationMap, leasingTeam) => {
      const { integrations = [] } = leasingTeam;

      integrations.forEach((integration) => {
        const { agents, vendor_property_id: vendorPropertyId } = integration;
        integrationMap[vendorPropertyId] = agents
          .map((agent) => {
            const { agent_id: id, agent_name: name } = agent;
            return { id, name };
          })
          .sort((agentA, agentB) => (agentA.name > agentB.name ? 1 : -1));
      });
      return integrationMap;
    },
    {}
  );

  return integrationAgentMap;
};

export const getUserIntegrationMap = (integrations = []) =>
  integrations.reduce((integrationMap, integration) => {
    integrationMap[integration.vendor_property_id] = integration;
    return integrationMap;
  }, {});

export const getMappedUserIntegrations = (
  leasingTeamIntegrations = [],
  userIntegrations = []
) => {
  const userIntegrationsMap = getUserIntegrationMap(userIntegrations);

  const mappedUserIntegrations = [...userIntegrations];

  leasingTeamIntegrations.forEach((leasingTeamIntegration) => {
    const { property_id, vendor, vendor_property_id } = leasingTeamIntegration;
    if (!userIntegrationsMap[vendor_property_id]) {
      const defaultUserIntegration = {
        property_id,
        vendor,
        vendor_property_id,
      };
      mappedUserIntegrations.push(defaultUserIntegration);
    }
  });

  return mappedUserIntegrations;
};

export const getIntegrationMap = (integrations) =>
  integrations.reduce((integrationsMap, integration) => {
    integrationsMap[integration.vendor_property_id] = integration;
    return integrationsMap;
  }, {});

export const addLeasingTeamIntegrations = (
  mappedUserIntegrations,
  selectedLeasingTeamIntegrations
) => {
  const integrationsMap = getIntegrationMap(mappedUserIntegrations);

  const updatedMappedUserIntegrations = [...mappedUserIntegrations];

  selectedLeasingTeamIntegrations.forEach((integration) => {
    if (!integrationsMap[integration.vendor_property_id]) {
      const { vendor, property_id, vendor_property_id } = integration;
      updatedMappedUserIntegrations.push({
        vendor,
        property_id,
        vendor_property_id,
      });
    }
  });

  return updatedMappedUserIntegrations;
};

export const removeLeasingTeamIntegrations = (
  mappedUserIntegrations,
  selectedLeasingTeamIntegrations
) => {
  const integrationsMap = getIntegrationMap(selectedLeasingTeamIntegrations);

  return mappedUserIntegrations.filter(
    (integration) => !integrationsMap[integration.vendor_property_id]
  );
};
